import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserService {
	static reload(): void {
		location.reload();
	}
}
